var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"assumptions-clickable readonly-column",attrs:{"flat":"","tile":""},on:{"click":function($event){return _vm.clickHandler()}}},[_c('span',[_vm._v(_vm._s(_vm.params.contents))])])
}
var staticRenderFns = []

export { render, staticRenderFns }